import React, {Component} from "react";
import {withNamespaces} from "react-i18next";

class ButtonCopy extends Component {

    state = {
        copyDone: false
    };

    copyToClipboard = (value) => {
        navigator.clipboard.writeText(value).then(
            () => this.setState({copyDone: true})
        )
    };

    render() {
        const {copyValue, buttonLabel, fullWidth, t} = this.props;
        const {copyDone} = this.state;


        return (
            <div>
                <button className={`btn btn-outline-info ${fullWidth ? 'w-100' : ''}`} onClick={() => this.copyToClipboard(copyValue)}>
                    <i className="fas fa-copy"> </i> &nbsp; {buttonLabel}
                </button>
                { !copyDone || (
                    <p className="alert-link">
                        {t('copy-to-cliboard-msg')}
                    </p>
                ) }
            </div>

        );
    }
};
export default withNamespaces()(ButtonCopy);
